define('plugin/push-notifications/model/PushNotificationsModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * PWA device Model
     *
     * @class PwaDeviceModel
     */
    return BaseModel.extend({

        url: '/push/info/',
        urlRegister: '/push/register-push/token/',

        defaults: {
            'status': null,
            'token': [],
            'client_id': null,
            'is_subscribed': true,
        },

        initialize: function () {

            this.on('sync', this._onModelSync);

            BaseModel.prototype.initialize.call(this);
        },

        disableSubscribe: function () {
            this.set({
                'is_subscribed': false,
                'status': 'disabled',
            });
        },

        subscribeToPush : function (token, callback) {
            var _this = this;
            var url = '/v2' + this.urlRegister + token;

            Backbone.ajax({
                'url': url,
                dataType : 'json',
                type : 'POST',
                data : '',
            }).success(function(data) {
                if(typeof callback === 'function') {
                    callback(data);
                }
                _this.set({
                    'is_subscribed' : true,
                    'token' : token,
                })
                _this.fetch();
            });

        },
        _onModelSync: function () {

        }
    });

});
